<template>
  <section class="row">
    <div class="col-12 mb-1">
      <div class="h5 mb-1">
        Assurup et vous
      </div>
      <p>
        Découvrez nos actualités et contenus qui peuvent vous intéresser !
      </p>
    </div>
    <div class="col-12 col-md-5 mb-2">
      <div
        class="card text-center box-shadow-yellow-300 h-100"
        style="min-height: 300px"
      >
        <div
          v-if="meetings.length === 0"
          class="card-body h-100 p-4
          d-flex flex-column justify-content-between"
        >
          <div class="h4">
            <span class="highlight highlight-pink-300">
              Vos rendez-vous
            </span>
          </div>
          <div class="h4">
            Aucun rendez-vous
          </div>
          <v-loader
            title="Prendre un rdv"
            icon="arrow-white-right"
            :next="openCalendly"
          />
        </div>
        <div
          v-else
          class="card-body h-100 p-4
          d-flex flex-column justify-content-between"
          style="min-height: 300px"
        >
          <div class="h4">
            <span class="highlight highlight-pink-300">
              Vos rendez-vous
            </span>
          </div>
          <div>
            <div class="h3 mb-0">
              {{ meetingDate }}
            </div>
            <div class="h5">
              {{ meetingHour }}
            </div>
          </div>
          <div class="d-flex flex-row mx-auto">
            <div
              class="position-relative fw-bold me-2"
              style="max-width: 50px; min-width: 50px"
            >
              <img
                class="rounded-circle img-fluid"
                :src="aws + '/elodie.png'"
              >
              <div class="green-circle rounded-circle border bg-green-600" />
            </div>
            <div class="d-flex flex-column">
              <div class="me-auto">
                {{ lastMeeting.assignedTo.civility === 'M'
                  ? 'Mon conseiller' : 'Ma conseillère' }}
              </div>
              <div class="me-auto fw-bold">
                {{ lastMeeting.assignedTo.firstName }}
              </div>
            </div>
          </div>
          <v-loader
            title="Annuler le rendez-vous"
            :next="openScheduleModal"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex';
import { ui } from '@/mixins';
import { formatDate } from '@/utils/_Date';

export default {
  name: 'HomepageNews',
  mixins: [ui],
  data() {
    return {
      lastPost: {
        title: { rendered: null },
        link: null,
        jetpack_featured_media_url: null,
      },
    };
  },
  computed: {
    meetings() {
      return this.$store.getters['client/meetings']
        .filter(({ status }) => status === 'CONFIRMED');
    },
    lastMeeting() {
      const meetings = [...this.meetings]
        .filter(({ status }) => status === 'CONFIRMED')
        .sort(({ startAt: a }, { startAt: b }) => {
          const aDate = (new Date(a)).getTime();
          const bDate = (new Date(b)).getTime();
          return aDate - bDate;
        });
      return meetings[0] || {};
    },
    meetingHour() {
      const date = new Date(this.lastMeeting.startAt);
      const [hour, minutes] = [date.getHours(), date.getMinutes()];
      return `${hour}H${minutes.toString().padEnd(2, 0)}`;
    },
    meetingDate() {
      return formatDate(
        this.lastMeeting.startAt,
        { year: 'numeric', month: 'long', day: 'numeric' },
      );
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/widget/png/account-manager`,
  },
  mounted() {
    this.$store.dispatch('client/findMeetingById');
    this.$store.dispatch('client/getMembers');
  },
  methods: {
    ...mapActions({
      storeOpenCalendly: 'ui/openCalendly',
    }),
    openCalendly() {
      const callback = async () => this.$store.dispatch('client/findMeetingById');
      return this.storeOpenCalendly(callback);
    },
    openScheduleModal() {
      this.ui_showModalSchedule(true);
      return Promise.resolve();
    },
  },
};
</script>

<style scoped>
.green-circle {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 30%;
  width: 30%;
  border: 2px solid #FFFFFF !important
}
.rounded-image {
  border-radius: 0 15px 15px 0
}
.image-blog {
  background-repeat: no-repeat;
  background-position: left;
  background-size: cover;
}
@media screen and (max-width: 992px) {
  .rounded-image {
    border-radius: 15px;
  }
  .container-image {
    min-height: 200px;
    margin-bottom: -25px;
    border-radius: 15px;
  }
}
</style>
